import { render, staticRenderFns } from "./OrderMessages.vue?vue&type=template&id=98a7e118"
import script from "./OrderMessages.vue?vue&type=script&lang=js"
export * from "./OrderMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports